import { Injectable } from '@nestjs/common';
import { ReasonsDTO } from './reasons.dto';
import {Reasons} from '../reasons.entity'

@Injectable()
export class ReasonsAdapter {
  
  public convertDtoToEntity(ReasonsDTO: ReasonsDTO,  isUpdate: boolean = false ): Reasons {
    const reasons = new Reasons();
    reasons.reasonId=ReasonsDTO.reasonId;
    reasons.reasonCode=ReasonsDTO.reasonCode;
    reasons.reasonName=ReasonsDTO.reasonName;
    reasons.category = ReasonsDTO.reasonCategory
    // company.isActive = statesDto.isActive == undefined ? true : statesDto.isActive;
    reasons.isActive=ReasonsDTO.isActive==undefined?true:ReasonsDTO.isActive;
    if (isUpdate) {
        reasons.updatedUser = ReasonsDTO.updatedUser;
    } else {
        reasons.isActive = true;
        reasons.createdUser =ReasonsDTO.createdUser;
    }
   return reasons;
  }
  public convertEntityToDto(reasonsObject: Reasons): ReasonsDTO {
    const reasonsDto= new ReasonsDTO;
    reasonsDto.reasonId=reasonsObject.reasonId;
    reasonsDto.reasonCode=reasonsObject.reasonCode;
    reasonsDto.reasonName=reasonsObject.reasonName;
    reasonsDto.isActive = reasonsObject.isActive;
    reasonsDto.createdAt = reasonsObject.createdAt;
    reasonsDto.updatedAt = reasonsObject.updatedAt;
    reasonsDto.createdUser = reasonsObject.createdUser;
    reasonsDto.updatedUser = reasonsObject.updatedUser;
    reasonsDto.versionFlag = reasonsObject.versionFlag;
    reasonsDto.reasonCategory =reasonsObject.category
    return reasonsDto;
  }
}